import { useTheme } from "@mui/material";
import { TableRow } from "./styled";
import TableCell from "./TableCell";
import { AthleteRowProps } from "./types";

/**
 * Utility function to convert rgb to rgba with full opacity
 */
const makeColorOpaque = (color: string | undefined): string => {
  if (!color) return "inherit";
  return color.replace("rgb", "rgba").replace(")", ", 1)");
};

/**
 * Component for displaying a single athlete row in the table
 */
const AthleteRow = ({
  athlete,
  columns,
  isCurrentAthlete,
  categoryColor,
  colors,
  onRowClick,
}: AthleteRowProps) => {
  const theme = useTheme();

  const handleClick = () => {
    if (onRowClick) {
      onRowClick(athlete);
    }
  };

  return (
    <TableRow categorycolor={categoryColor} onClick={handleClick}>
      {columns.map((column) => (
        <TableCell
          key={`${athlete.id}-${column.id}`}
          colors={colors}
          frozen={column.frozen}
          isHighlighted={isCurrentAthlete}
          flex={column.flex}
          minWidth={column.minWidth}
          align={column.align}
          categorycolor={categoryColor}
          sx={{
            textAlign: column.align || "left",
            justifyContent: column.align === "center" ? "center" : "flex-start",
            bgcolor: column.frozen
              ? categoryColor
                ? makeColorOpaque(categoryColor)
                : theme.palette.background.default || "white"
              : categoryColor
                ? makeColorOpaque(categoryColor)
                : "inherit",
          }}
        >
          {column.render(athlete)}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default AthleteRow;
